import { formatUSD } from '../../helpers';
import AnalyticsSmallCard from './AnalyticsSmallCard';
// import useAnalytics from '../../hooks/analytics/useAnalytics';
import useMockAnalytics from '../../hooks/analytics/useMockAnalytics';

const NewPositions = () => {
    const { analytics, isLoading, defaultData } = useMockAnalytics();

    return (
        <AnalyticsSmallCard
            title='24h New Positions'
            percentageDifference={
                analytics
                    ? analytics.dailyNewPositions.dailyDiffPercentage.toString()
                    : '0'
            }
            amount={formatUSD(
                analytics?.dailyNewPositions.currentValue.toString() || '0',
                { maxDecimals: 0, currency: '' }
            )}
            data={analytics?.dailyNewPositions.historicalData ?? defaultData}
            isLoading={isLoading}
            showPercentage
        />
    );
};

export default NewPositions;
